import { useMutation } from "@tanstack/react-query";
import { SignUpFormValues, SignUpRemoteFormValues } from "ui-components";
import { apiInstance, tryCatch } from "utils";
import { customAlphabet } from "nanoid";
import { isAxiosError } from "axios";

export const useSignUp = () => {
	return useMutation({
		mutationKey: ["signUp"],
		mutationFn: async (values: SignUpFormValues & SignUpRemoteFormValues) => {
			const companyName = getRandomCompanyName();
			const companySlug = await getCompanySlug(companyName);

			const postForm = new FormData();
			postForm.append("user[first_name]", values.name);
			postForm.append("user[last_name]", getRandomizedChars());
			postForm.append("user[user_name]", companyName);
			postForm.append("user[portal_url]", companySlug);
			postForm.append("user[phone]", "855123456789");
			postForm.append("user[email]", values.email);
			postForm.append("user[password]", values.password);

			return apiInstance.post("/clients/create_account.json", postForm);
		},
	});
};

const PREFIXES = [
	"atlas",
	"bay",
	"cape",
	"delta",
	"edge",
	"fjord",
	"grid",
	"hill",
	"isle",
	"jet",
	"key",
	"land",
	"mesa",
	"node",
	"park",
	"quad",
	"ridge",
	"sea",
	"trail",
	"vale",
	"wave",
	"zone",
	"arc",
	"cliff",
	"dune",
	"east",
	"field",
	"gulf",
	"harbor",
	"inlet",
	"knoll",
	"lake",
	"mount",
	"north",
	"ocean",
	"path",
	"range",
	"south",
	"trace",
	"under",
	"view",
	"west",
	"yard",
	"zenith",
	"basin",
	"creek",
	"depth",
	"fleet",
	"grove",
];

function getRandomCompanyName() {
	const prefix = PREFIXES[Math.floor(Math.random() * PREFIXES.length)];
	const suffix = getRandomizedChars();

	return `${prefix} ${suffix}`;
}

function getRandomizedChars() {
	return customAlphabet(
		"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
		8,
	)();
}

const getCompanySlug = async (value: string) => {
	const [error, data] = await tryCatch(
		apiInstance.get<{
			portal_url: string | null;
			status: string;
			users: Record<string, any>[];
		}>(`/account/search?term=${encodeURIComponent(value)}&qc=name`),
	);

	if (error) {
		if (isAxiosError(error)) throw new Error("Something went wrong!");
		throw new Error(error.message);
	}
	if (!data.portal_url) throw new Error("Invalid company name");

	return data.portal_url;
};
